import { Component, ComponentFactoryResolver, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import * as Papi from '@app/papi';
import { AlertService } from '../_services/alert.service';
import { AlertComponent } from '../_directives/alert.component';
import { ResetCustom } from '../_helpers/reset-custom';
import { Helpers } from '../../helpers';
import { AuthResetPassword } from 'papi-client-ng2';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';

@Component({
	selector: 'reset-pass.m-grid.m-grid--hor.m-grid--root.m-page',
	templateUrl: './reset-pass.component.html',
	encapsulation: ViewEncapsulation.None,
	standalone: false
})

export class ResetPassComponent implements OnInit {
	@ViewChild('resetSuccess', { static: true }) private resetSuccess: SwalComponent;
	@ViewChild('resetError', { static: true }) private resetError: SwalComponent;

	public model: any = {};
	public email: string = '';
	public loading = false;

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private papi: Papi.Service,
		private alertService: AlertService,
		private cfr: ComponentFactoryResolver) {
	}

	ngOnInit(): void {
		this.email = this.route.snapshot.paramMap.get('email');
		Helpers.setLoading(false);
		ResetCustom.init();
	}

	resetPass() {
		const model: AuthResetPassword = {
			password: this.model.password,
			verifyPassword: this.model.verifyPassword,
			verificationCode: this.model.verificationCode,
			userEmail: this.email
		};

		this.loading = true;
		this.papi.fauxInit();
		this.papi.db.authResetPassword(model, 'body', true).subscribe((data) => {
			this.resetSuccess.fire().then(() => {
				this.loading = false;
				this.router.navigate(['login']);
			});
		}, (error) => {
			this.resetError.text = error.error.message || error.error.error.message || 'There was an error resetting your password.';
			this.resetError.fire().then(() => {
				this.loading = false;
			});
		});
	}

	cancel() {
		this.router.navigate(['login']);
	}
}